export default __webpack_public_path__ + "media/images/cherryblossom-5d8183da7d201872f72b62bd80f8f73b.jpg";